<template>
	<modal
		:modal-id="modalId"
		:title="modalTitle"
		:preloader="preloader"
		@submit="submit"
		@close-modal="closeModal"
	>
		<template slot="body">
			<app-overlay-loader v-if="preloader" />
			<form
				class="mb-0"
				:class="{ 'loading-opacity': preloader }"
				ref="form"
				:data-url="
					selectedUrl
						? `transaction/lead/${inputs.id}`
						: `transaction/lead`
				"
			>
				<div class="form-group row align-items-center">
					<label for="inputs_parent_first_name" class="col-sm-3 mb-0">
						Parent First Name
					</label>
					<app-input
						id="inputs_parent_first_name"
						class="col-sm-9"
						type="text"
						v-model="inputs.parent_first_name"
						placeholder="Parent Name"
						:required="true"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_parent_last_name" class="col-sm-3 mb-0">
						Parent Last Name
					</label>
					<app-input
						id="inputs_parent_last_name"
						class="col-sm-9"
						type="text"
						v-model="inputs.parent_last_name"
						placeholder="Parent Name"
						:required="true"
					/>
				</div>

				<div class="form-group row align-items-center">
					<label for="inputs_contact_number" class="col-sm-3 mb-0">
						Contact Number
					</label>
					<app-input
						id="inputs_contact_number"
						class="col-sm-9"
						type="tel-input"
						v-model="inputs.parent_contact"
						placeholder="Contact Number"
						:required="true"
					/>
				</div>
				<!-- <div class="form-group row align-items-center">
					<label for="inputs_first_name" class="col-sm-3 mb-0">
						First Name
					</label>
					<app-input
						id="inputs_first_name"
						class="col-sm-9"
						type="text"
						v-model="inputs.first_name"
						placeholder="First Name"
						:required="true"
					/>
				</div> -->
				<!-- <div class="form-group row align-items-center">
					<label for="inputs_lastname" class="col-sm-3 mb-0">
						Last Name
					</label>
					<app-input
						id="inputs_lastname"
						class="col-sm-9"
						type="text"
						v-model="inputs.last_name"
						placeholder="Last Name"
						:required="true"
					/>
				</div> -->
				<div class="form-group row align-items-center">
					<label for="inputs_name" class="col-sm-3 mb-0">
						Name
					</label>
					<app-input
						id="inputs_name"
						class="col-sm-9"
						type="text"
						v-model="inputs.name"
						placeholder="Name"
						:required="true"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="input_date_of_birth" class="col-sm-3 mb-0">
						Date of Birth
					</label>
					<app-input
						id="input_date_of_birth"
						class="col-sm-9"
						type="date"
						v-model="inputs.date_of_birth"
						placeholder="Date of Birth"
						:required="true"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label class="col-sm-3 mb-sm-0"> Interested In </label>
					<app-input
						class="col-sm-9"
						placeholder="Interested In"
						type="search-select"
						:list="learningInterestLists"
						name="learning_interests"
						v-model="inputs.learning_interests"
						:isAnimatedDropdown="true"
						required
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_nearest_clc" class="col-sm-3 mb-0">
						Nearest CLC
					</label>
					<app-input
						id="inputs_nearest_clc"
						class="col-sm-9"
						type="search-select"
						v-model="inputs.center_id"
						placeholder="Nearest CLC"
						:list="nearestClcList"
						:required="true"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_status" class="col-sm-3 mb-0">
						Status
					</label>
					<app-input
						id="inputs_status"
						class="col-sm-9"
						type="advance-search-select"
						:loaded-per-time="10"
						v-model="input_status"
						@input="setStatusValue"
						fetch-url="/master/lead-status?lead_status_id=null&per_page=50"
						:placeholder="'Status'"
						list-value-field="status"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_sub_status" class="col-sm-3 mb-0">
						Sub Status
					</label>
					<app-input
						id="inputs_sub_status"
						class="col-sm-9"
						type="advance-search-select"
						:loaded-per-time="10"
						v-model="input_sub_status"
						@input="setSubStatusValue"
						:fetch-url="`/master/lead-status?lead_status_id=${input_status.id}&per_page=50`"
						:placeholder="'Sub Status'"
						list-value-field="status"
						:disabled="
							this.input_status.id === '' ||
							this.input_status.id === null ||
							this.input_status.id === 0
						"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_reason" class="col-sm-3 mb-0">
						Reason
					</label>
					<app-input
						id="inputs_reason"
						class="col-sm-9"
						type="advance-search-select"
						:loaded-per-time="10"
						v-model="input_reason"
						@input="setReasonValue"
						:fetch-url="`/master/lead-status-reason?lead_status_id=${input_sub_status.id}&per_page=50`"
						:placeholder="'Reason'"
						list-value-field="reason"
						:disabled="
							this.input_sub_status.id === '' ||
							this.input_sub_status.id === null ||
							this.input_sub_status.id === 0
						"
					/>
				</div>
				<!-- <div class="form-group row align-items-center">
					<label for="inputs_reason" class="col-sm-3 mb-0">
						Reason Not Interested
					</label>
					<app-input
						id="inputs_reason"
						class="col-sm-9"
						type="search-select"
						v-model="inputs.reason"
						placeholder="Reason Not Interested"
						:list="reason_list"
						:required="true"
					/>
				</div> -->
				<div class="form-group row align-items-center">
					<label for="input_last_updated" class="col-sm-3 mb-0">
						Last Updated
					</label>
					<app-input
						id="input_last_updated"
						class="col-sm-9"
						type="date"
						v-model="inputs.updated_at"
						placeholder="Last Updated"
						:required="true"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_assigned_to" class="col-sm-3 mb-0">
						Assigned To
					</label>
					<app-input
						id="inputs_assigned_to"
						class="col-sm-9"
						type="search-select"
						v-model="inputs.cc_id"
						placeholder="Assigned To"
						:list="assignedToLists"
						:required="true"
						:disabled="
							this.$can(
								'view_list_lead_button_modalupdateinfo_edit_assignto'
							) === false
						"
					/>
				</div>
			</form>
		</template>
	</modal>
</template>

<script>
import { LeadListFormMixin } from "./LeadListFormMixin.js";
import { ModalMixin } from "../../../../../Mixins/ModalMixin";

export default {
	name: "LeadListForm",
	mixins: [LeadListFormMixin, ModalMixin],
	props: {
		tableId: String,
		formId: String,
		value: {
			type: Object,
			default: () => {
				return {};
			},
		},
	},
	data() {
		return {
			preloader: false,
			inputs: {},
			phone: "",
			modalId: this.formId,
			modalTitle: this.$t("add"),
			nearestClcList: [],
			assignedToLists: [],
			// subStatusLists: [
			// 	{ id: "5", value: "Open" },
			// 	{ id: "waiting_interview", value: "Waiting Interview" },
			// 	{ id: "Leave Message", value: "Leave Message" },
			// 	{ id: "call_again", value: "Call Again" },
			// 	{ id: "phone_invalid", value: "Phone Invalid" },
			// 	{ id: "phone_not_answered", value: "Phone Not Answered" },
			// 	{ id: "not_interested", value: "Not Interested" },
			// ],
			subStatusLists: [],
			reason_list: [
				{ id: "price", value: "Price" },
				{ id: "schedule", value: "Schedule" },
				{ id: "clc_rules", value: "CLC Rules" },
				{ id: "no_app", value: "No App" },
				{ id: "not_available", value: "Not Available" },
			],
			learningInterestLists: [],
			input_status: this.value
				? this.value.status
					? {
							id: this.value.status.id || 0,
							status: this.value.status.status || "",
					  }
					: {
							id: this.value.status?.id || 0,
							status: this.value.status?.status || "",
					  }
				: {
						id: this.value.status.id || 0,
						status: this.value.status.status || "",
				  },
			input_reason: this.value
				? this.value.status_reason
					? {
							id: this.value.status_reason.id || 0,
							reason: this.value.status_reason.reason || "",
					  }
					: {
							id: this.value.status_reason?.id || 0,
							reason: this.value.status_reason?.reason || "",
					  }
				: {
						id: this.value.status_reason.id || 0,
						reason: this.value.status_reason.reason || "",
				  },
			input_sub_status: this.value
				? this.value.sub_status
					? {
							id: this.value.sub_status.id || 0,
							status: this.value.sub_status.status || "",
					  }
					: {
							id: this.value.sub_status?.id || 0,
							status: this.value.sub_status?.status || "",
					  }
				: {
						id: this.value.sub_status.id || 0,
						status: this.value.sub_status.status || "",
				  },
		};
	},
	created() {
		if (this.selectedUrl) {
			this.modalTitle = this.$t("edit");
			this.preloader = true;
		}

		this.fetchData();
	},
	methods: {
		async fetchData() {
			try {
				if (this.selectedUrl) {
					this.modalTitle = this.$t("edit");
					this.preloader = true;
				}

				let [
					userResponse,
					centerResponse,
					leadStatusResponse,
					learningInterestResponse,
				] = await Promise.all([
					axios.get("/user-list?per_page=50"),
					axios.get("/master/center?is_active=true&per_page=50"),
					axios.get(
						"/master/lead-status?lead_status_id=1&per_page=50"
					),
					axios.get("/master/learning-interest?is_active=true&per_page=50"),
				]);

				userResponse.data.data.forEach((item) => {
					this.assignedToLists.push({
						id: item.id,
						value: item.full_name
							? item.full_name
							: item.first_name + " " + item.last_name,
					});
				});

				centerResponse.data.data.forEach((item) => {
					this.nearestClcList.push({
						id: item.id,
						value: item.name,
					});
				});

				this.subStatusLists = leadStatusResponse.data.data.map(
					(item) => ({
						id: item.id,
						value: item.status,
					})
				);

				learningInterestResponse?.data?.data?.forEach((item) => {
					this.learningInterestLists.push({
						id: item.id,
						value: item.name,
					});
				});
			} catch (error) {
				console.error("Error fetching data:", error);
			}
		},
		submit() {
			this.inputs.parent = {
				id: this.inputs.parent_id,
				name: this.inputs.parent_first_name,
				last_name_parents: this.inputs.parent_last_name,
				contact: this.inputs.parent_contact,
			};
			this.save(this.inputs);
		},
		afterSuccess(response) {
			this.$toastr.s(response.data.message);
			this.$hub.$emit("reload-" + this.tableId);
		},

		afterSuccessFromGetEditData(response) {
			this.inputs = response.data;
			this.inputs.parent_id = this.inputs.parent?.id;
			this.inputs.parent_first_name = this.inputs.parent?.name;
			this.inputs.parent_last_name = this.inputs.parent?.last_name_parents
			this.inputs.parent_contact = this.inputs.parent?.contact;
			this.inputs.learning_interests = this.inputs.learning_interests?.id

			this.input_status = {
				id: this.inputs.status?.id || 0,
				status: this.inputs.status?.status || "",
			};

			this.input_sub_status = {
				id: this.inputs.sub_status?.id || 0,
				status: this.inputs.sub_status?.status || "",
			};

			this.input_reason = {
				id: this.inputs.status_reason?.id || 0,
				reason: this.inputs.status_reason?.reason || "",
			};

			this.preloader = false;
		},

		setStatusValue(data) {
			this.inputs.status_id = this.inputs.status_id;
			if (data && data.hasOwnProperty("id")) {
				this.inputs.status_id = data.id;
			}
		},
		setSubStatusValue(data) {
			this.inputs.sub_status_id = this.inputs.sub_status_id;
			if (data && data.hasOwnProperty("id")) {
				this.inputs.sub_status_id = data.id;
			}
		},
		setReasonValue(data) {
			this.inputs.reason_id = this.inputs.reason_id;
			if (data && data.hasOwnProperty("id")) {
				this.inputs.reason_id = data.id;
			}
		},
	},
};
</script>
